import {OrderDto} from "./order.dto";

export class PaypalOrderDto extends OrderDto {

  public readonly paypalId!: string;
  public readonly payerId: string | undefined;

  constructor(init?: Partial<PaypalOrderDto> | undefined) {
    super(init);
    Object.assign(this, init);
  }
}
